import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "./config";

const functions = getFunctions(app);

// Legacy: full pipeline (Azure OCR + GPT) in one call. Kept for backward compatibility.
export async function extractInvoiceData(url) {
  const extract = httpsCallable(functions, "extractInvoiceData");
  const response = await extract({ url });
  const data = response.data || {};
  if (data.error) return { error: data.error };
  const {
    issue_date,
    grand_total,
    issuer_company_name,
    issuer_vat,
    invoice_number,
  } = data;
  return {
    issue_date,
    grand_total,
    issuer_company_name,
    issuer_vat,
    invoice_number,
  };
}

// Step 1: Azure Document Intelligence (prebuilt-read). Returns { ocrText } or { error }.
export async function runAzureOcr(url) {
  const fn = httpsCallable(functions, "runAzureOcr");
  const res = await fn({ url });
  const data = res.data || {};
  if (data.error) return { error: data.error };
  return { ocrText: data.ocrText || "" };
}

// Step 2: GPT structured extraction over the OCR text.
// Returns the mapped invoice fields or { error }.
export async function runGptExtract(ocrText) {
  const fn = httpsCallable(functions, "runGptExtract");
  const res = await fn({ ocrText });
  const data = res.data || {};
  if (data.error) return { error: data.error };
  const {
    issue_date = '',
    grand_total = '',
    issuer_company_name = '',
    issuer_vat = '',
    invoice_number = '',
  } = data;
  return {
    issue_date,
    grand_total,
    issuer_company_name,
    issuer_vat,
    invoice_number,
  };
}
